"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleSerieType = void 0;
var ArticleSerieType;
(function (ArticleSerieType) {
    ArticleSerieType["leitungSerie"] = "leitungSerie";
    ArticleSerieType["ketteSerie"] = "ketteSerie";
})(ArticleSerieType = exports.ArticleSerieType || (exports.ArticleSerieType = {}));
//# sourceMappingURL=ArticleSerieType.js.map